function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgCss = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 32 32"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M5.902 27.201 3.656 2h24.688l-2.249 25.197L15.985 30z",
  style: {
    fill: "#1572b6"
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "m16 27.858 8.17-2.265 1.922-21.532H16z",
  style: {
    fill: "#33a9dc"
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "M16 13.191h4.09l.282-3.165H16V6.935h7.75l-.074.829-.759 8.518H16z",
  style: {
    fill: "#fff"
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "m16.019 21.218-.014.004-3.442-.93-.22-2.465H9.24l.433 4.853 6.331 1.758.015-.004z",
  style: {
    fill: "#ebebeb"
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "m19.827 16.151-.372 4.139-3.447.93v3.216l6.336-1.756.047-.522.537-6.007z",
  style: {
    fill: "#fff"
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "M16.011 6.935v3.091H8.545l-.062-.695-.141-1.567-.074-.829zM16 13.191v3.091h-3.3989999999999996l-.062-.695-.14-1.567-.074-.829z",
  style: {
    fill: "#ebebeb"
  }
}));
export default SvgCss;